import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { listPatientVisits } from "../actions/visitActions";
import Skeleton from "react-loading-skeleton";
import Message from "./Message";
import { Form } from "react-bootstrap";
import {
  LIST_PATIENT_VISITS_RESET,
  VISIT_CREATE_RESET,
} from "../constants/visitConstants";
import { notify } from "./notify";
import { Howl } from "howler";
import VisitAccordion from "./VisitAccordion";

const VisitsOfPatient = ({
  isSecretary,
  currentAge,
  patientId,
  tradeLabels,
  patientVehicle,
  isPhysician,
  isNurse,
  setShowSecretaryForm,
}) => {
  const [visitsVehicle, setVisitsVehicle] = useState();
  const [expandAllRev, setExpandAllRev] = useState();
  const [error, setError] = useState("");

  const visitsOfPatientStore = useSelector(
    (state) => state.visitsOfPatientStore,
  );
  const {
    noRequest,
    loading,
    patientVisits,
    error: visitsOfPatientErr,
  } = visitsOfPatientStore;

  const visitAddStore = useSelector((state) => state.visitAddStore);
  const { loading: loadNewVisit, newVisit, error: newVisitErr } = visitAddStore;

  const handleExpand = () => {
    if (!expandAllRev) {
      setExpandAllRev("expand");
    } else {
      setExpandAllRev();
    }
  };

  const dispatch = useDispatch();

  useEffect(() => {
    if (!patientVehicle || patientVehicle._id !== patientId) {
      setVisitsVehicle();
    }

    if (!visitsVehicle && noRequest) {
      dispatch(listPatientVisits(patientId));
    }

    if (patientVisits) {
      setVisitsVehicle(patientVisits);
      dispatch({ type: LIST_PATIENT_VISITS_RESET });
    }

    if (newVisit) {
      notify({
        title: "Visit Success",
        message: <p className="lead">Visit added successfully.</p>,
        type: "success",
        duration: 3000,
      });
      var sound = new Howl({
        src: `/success.mp3`,
      });
      sound.play();
      setVisitsVehicle();
      setShowSecretaryForm(false);
      dispatch({ type: VISIT_CREATE_RESET });
    }

    if (visitsOfPatientErr) {
      setError(visitsOfPatientErr);
    }
  }, [
    patientId,
    dispatch,
    patientVisits,
    noRequest,
    patientVehicle,
    newVisit,
    visitsVehicle,
    noRequest,
    visitsOfPatientErr,
  ]);
  return (
    <div className="mt-3">
      {/* <pre>{JSON.stringify(visitsVehicle, null, 2)}</pre> */}
      <h3>Visit History:</h3>
      {visitsVehicle?.length === 0 && isSecretary && (
        <Message
          children={`Patient has No visits yet. Add one below 👇👇`}
          variant={`info`}
        />
      )}
      {visitsVehicle?.length === 0 && !isSecretary && (
        <Message
          children={`Patient has NO visits yet. Please wait while the secretary adds one!`}
          variant={`info`}
        />
      )}
      {error && (
        <Message
          children={`Get Patient Visits Err: ${error}`}
          variant={`danger`}
        />
      )}
      {loading && <Skeleton height="120px" className="mb-5" />}

      {visitsVehicle?.length > 0 && (
        <>
          <Form.Check
            type="switch"
            id="expand"
            onChange={() => handleExpand()}
            label="Expand All"
          />

          {visitsVehicle.map((v) => (
            <div key={v._id} className="my-2">
              <VisitAccordion
                visit={v}
                tradeLabels={tradeLabels}
                patientVehicle={patientVehicle}
                expandAllRev={expandAllRev}
                isNurse={isNurse}
                isPhysician={isPhysician}
                currentAge={currentAge}
                setVisitsVehicle={setVisitsVehicle}
              />
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default VisitsOfPatient;
